import { CustomReportSectionData } from "@/v2/entities/custom-report/CustomReport.model";
import { Flex, Text, Heading, Container } from "@radix-ui/themes";
import { useMemo } from "react";
import styles from "./CustomReportSection.module.scss";

interface CustomReportSectionProps {
  data: CustomReportSectionData;
}

export function CustomReportSection({ data }: CustomReportSectionProps) {
  const sectionId = useMemo(() => {
    if (!data.title) return undefined;
    return data.title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }, [data.title]);

  return (
    <Container id={sectionId} style={{ flexGrow: 0 }}>
      <Flex
        className="bg-muted rounded-md p-5"
        direction="row"
        gap="5"
        align="center"
      >
        <Flex
          direction="column"
          align="center"
          justify="center"
          gap="1"
          className={styles.leftSection}
        >
          <Text as="span" size="5" weight="bold">
            {data.ticketCount}
          </Text>
          <Text as="span" size="2">
            ticket volume
          </Text>
        </Flex>

        <Flex direction="column" gap="4" style={{ flex: 1 }}>
          {data.title && (
            <Heading size="6" as="h2" color="gray" highContrast>
              {data.title}
            </Heading>
          )}

          {data.keyThemes.length > 0 && (
            <Flex direction="column" gap="2">
              <Heading size="3" as="h3" color="gray" highContrast>
                Key Themes
              </Heading>
              <div className={styles.themeList}>
                {data.keyThemes.map((theme, index) => (
                  <span key={index} className={styles.themeTag}>
                    {theme}
                  </span>
                ))}
              </div>
            </Flex>
          )}

          {data.quotes.length > 0 && (
            <Flex direction="column" gap="2">
              <Heading size="3" as="h3" color="gray" highContrast>
                Quotes
              </Heading>
              <div className={styles.quoteList}>
                {data.quotes.map((quote, index) => (
                  <div key={index} className={styles.quoteItem}>
                    "{quote}"
                  </div>
                ))}
              </div>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Container>
  );
}
